import React, { useLayoutEffect, useMemo, useState } from 'react';
import { Box, useResponsive } from '@common-fe/common-fe';

import { useHistory } from '@/modules/core/hooks';
import useReceiptsFeatureFlag from '@/modules/MyDocuments/hooks/useReceiptsFeatureFlag';

import LettersOfMedicalNecessity from './components/LettersOfMedicalNecessity/LettersOfMedicalNecessity';
import MyDocumentsHeader from './components/MyDocumentsHeader';
import Receipts from './components/Receipts/Receipts';
import Statements from './components/Statements/Statements';
import TaxForms from './components/TaxForms/TaxForms';
import { MyDocumentsTabs, MyDocumentsTabsRoutes } from './myDocuments.types';

const MyDocuments = () => {
  const { isMobile } = useResponsive();
  const history = useHistory();
  const { isReceiptsEnabled } = useReceiptsFeatureFlag();

  const defaultTab = useMemo(() => {
    const availableTab = isReceiptsEnabled
      ? MyDocumentsTabs.RECEIPTS
      : MyDocumentsTabs.LMN;
    return MyDocumentsTabsRoutes?.[history.location.pathname] || availableTab;
  }, [isReceiptsEnabled, history]);

  const [tab, setTab] = useState<string>(defaultTab);

  useLayoutEffect(() => {
    const pageRoute = Object.keys(MyDocumentsTabsRoutes).find(
      (pageKey) => MyDocumentsTabsRoutes?.[pageKey] === tab
    );
    if (pageRoute) {
      history.push(pageRoute);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <Box data-testId="my-documents-page" margin={{ bottom: isMobile ? 'spacing16' : 'spacing24' }}>
      <MyDocumentsHeader tab={tab} setTab={setTab} />
      <Box margin={{ top: 'spacing24' }} data-testId="my-documents-page_tab-wrapper">
        {tab === MyDocumentsTabs.RECEIPTS ? <Receipts /> : null}
        {tab === MyDocumentsTabs.LMN ? <LettersOfMedicalNecessity /> : null}
        {tab === MyDocumentsTabs.STATEMENTS ? <Statements /> : null}
        {tab === MyDocumentsTabs.TAX_FORMS ? <TaxForms /> : null}
      </Box>
    </Box>
  );
};

export default MyDocuments;
